import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { getBaseQuery, getBaseUrl } from '../../Utils'
import { createApi } from '@reduxjs/toolkit/query/react'
import { RootState } from '../store'
import APIHelper from '../HelperMethodsForAPI'

export interface deleteVUData {
    DashboardId: number
    VisualUnitId: number
    PrivacyLock: string
}
export interface detachVUData {
    dashboardId: number
    visualUnitId: number
}

export interface toggleEmailNotificationData {
    VisualUnitId: number
    Toggle: string
}
export interface DefaultVisualUnitProps {
    VisualUnitId: number
    ViewerType: string
    ChartSettings?: object
    ChartSwitch?: string
    TableSettings?: object
}
export interface ExportXlsxPayload {
    dashBoardId: number
    visualUnitId: number
    tempVisualUnitId: number
    pageSize: number
    pageNumber: number
    sortColumn: string
    sortOrder: string
    viewerTypeChanged: boolean
    viewerType: number
    forceRefresh: number
}
export interface APIResponse {
    data: any
}
interface IActionVuid{
    isActionOpen: boolean
}
interface IAction {
    reportActionOpenList: IActionVuid
}

export interface IVuActions {
    isActionOpen: boolean
}

export interface ReportsActionState {
    reportActionsOpenState: { [vuId: number]: IVuActions };
}
const initialState: ReportsActionState = {
    reportActionsOpenState: {},
};

const reportsActionSlice = createSlice({
    name: 'reportsActions',
    initialState,
    reducers: {
        setActionsOpenObj: (state, action: PayloadAction<{ vuId: number; isActionOpen: IVuActions }>) => {
            const { vuId, isActionOpen } = action.payload;
            state.reportActionsOpenState[vuId] = isActionOpen; // Update settings by specific vuId
        },
    },
});

export const visualUnitApi = createApi({
    reducerPath: 'visualUnitApi',
    tagTypes: [
        'deleteVUData',
        'detachVUData',
        'copyVUData',
        'toggleEmailNotificationData',
        'exportVisualUnitData',
        'DefaultVisualUnitProps',
    ],
    baseQuery: getBaseQuery( getBaseUrl() + 'API/v3/' ),
    endpoints: (builder) => ({
        deleteVisualUnit: builder.mutation<any, FormData>({
            query: (formData) => ({
                url: 'visualunit/DeleteVisualUnit',
                method: 'DELETE',
                body:formData
            }),
            invalidatesTags: ['deleteVUData'],
        }),
        detachVisualUnit: builder.mutation<APIResponse, { wsid: string | undefined; body: FormData }>({
            query: ({ wsid, body }) => ({
                url: `Workspace/${wsid}/visualunits`,
                method: 'DELETE',
                body,
            }),
            invalidatesTags: ['detachVUData'],
        }),
        copyVisualUnit: builder.mutation({
            query: ({ body }) => ({
                url: `visualunit/Create`, 
                method: 'POST',
                body : APIHelper.prepareFormData(body),
            }),
            invalidatesTags: ['copyVUData'], 
        }),
        toggleEmailNotification: builder.mutation<APIResponse, FormData>({
            query: (formData) => ({
                url: `visualunit/ToggleEmail`,
                method: 'PUT',
                body: formData,
            }),
            invalidatesTags: ['toggleEmailNotificationData'],
        }),
        exportVisualUnitAsExcel: builder.mutation<APIResponse, ExportXlsxPayload>({
            query: (payload) => ({
                url: `Drillthru/ExportXlsx`,
                method: 'POST',
                body: payload,
            }),
            invalidatesTags: ['exportVisualUnitData'],
        }),
        setDefaultVisualUnitProps: builder.mutation<APIResponse, FormData>({
            query: (formData) => {
                return {
                    url: 'visualunit/ChangeVUDefaults',
                    method: 'POST',
                    body: formData,
                }
            },
            invalidatesTags: ['DefaultVisualUnitProps'],
        }),
        fetchExecutePayload: builder.mutation<any, { wsid: any; Id: number }>({
            query: ({ wsid, Id }) => ({
                url: `visualunit/${wsid}/${Id}`,
                method: 'GET',
            }),        
        }),
        checkEditSave: builder.mutation({
            query: ({ VisualUnitId, DashboardId, DashboardName }) => ({
              url: 'visualunit/CheckEditSave', 
              method: 'POST',
              body: { VisualUnitId, DashboardId, DashboardName },
            }),
          }),
        EditSaveVU: builder.mutation({
            query: (reqVisualUnitData) => ({
              url: 'visualunit/EditSaveVU',
              method: 'PUT',
              body: reqVisualUnitData,
            }),
          }),
          downloadChart: builder.mutation<void, { filename: string; type: string; width: string | undefined; scale: number; svg: string }>({
            query: (payload) => ({
              url: 'visualunit/SaveChartAsImage',
              method: 'POST',
              body: APIHelper.prepareFormData(payload),
            }),
          }),  
    }),
})

export const {
    useDeleteVisualUnitMutation,
    useDetachVisualUnitMutation,
    useCopyVisualUnitMutation,
    useToggleEmailNotificationMutation,
    useExportVisualUnitAsExcelMutation,
    useSetDefaultVisualUnitPropsMutation,
    useFetchExecutePayloadMutation,
    useCheckEditSaveMutation,
    useEditSaveVUMutation,
    useDownloadChartMutation,
} = visualUnitApi

// export const { setReportActionToggle } = reportActionsSlice.actions;
// export const getReportActionToggle = (state: RootState) => state.reportActionsOpen.activeActionPanel;
// export default reportActionsSlice.reducer

export const { setActionsOpenObj } = reportsActionSlice.actions;
export const getReportActionsObj = (state: RootState) => state.toggleReportAction.reportActionsOpenState;
export default reportsActionSlice.reducer;


